import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import PropTypes from "prop-types";

import css from "./activity_type_badge.module.scss";

const ICON_NAMES = {
  role: "role",
  event: "calendar",
  question: "question",
  suggestion: "chat",
  position: "work",
  lesson: "book",
  engagement: "engagement",
  project: "path"
};

const ActivityTypeBadge = ({ type }) => {
  const iconName = ICON_NAMES[type.key];

  return (
    <Inline gap="spacingMd" className={css.root}>
      {iconName && <Icon name={iconName} size="sm" />}
      <Typography variant="labelRegular">{type.name}</Typography>
    </Inline>
  );
};

ActivityTypeBadge.propTypes = {
  type: PropTypes.shape({ key: PropTypes.string, name: PropTypes.string }).isRequired
};

export default ActivityTypeBadge;
